import * as React from "react";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { Alert, Grid, Icon, Snackbar, Switch, Tooltip } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import { useEffect, useState } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUserData, getAuthorizationHeader } from "Utils/helpers";
import { postData } from "Utils/server";
import "assets/theme/base/animation.css";

const oddsStylesList = {
  fractional: "FR",
  moneyline: "US",
  hongKong: "HK",
  malay: "MA",
  indonesian: "IN",
  decimal: "",
};
//let cachedOdds = [];
function MarketView({ market, massClose, oddsStyle, informParent, releaseOperBlocked }) {
  const userData = getUserData();
  let adminRole = userData && userData.roles.find((item) => item.id < 50);

  const [marketData, setMarketData] = useState(null);
  const [open, setOpen] = useState(true);
  const [cachedOdds, setCachedOdds] = useState([]);
  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [operatorBlockedOdds, setOperatorBlockedOdds] = useState([]);
  const [operatorBlockedMarkets, setOperatorBlockedMarkets] = useState([]);

  function showOddWithStyle(odd) {
    const selectedOdd = oddsStylesList[oddsStyle];
    return !selectedOdd || (selectedOdd == "" && oddsStyle == "decimal")
      ? (Math.round(odd[`odd${selectedOdd}`] * 100) / 100).toFixed(2)
      : odd[`odd${selectedOdd}`];
  }

  function clickHandler(e, market) {
    e.preventDefault();
    //console.log("m_name clicked: ", m_name);
    if (e.target.name == "market-filter-switch") {
      setMarketFilter(e, market.id);
      return;
    }
    setOpen(!open);
  }

  function createColumn(odds, index, marketUniName) {
    let rows = [];
    let activeOdds = odds.filter((item) => item.status != "deleted");
    for (let index = 0; index < activeOdds.length; index++) {
      const odd = activeOdds[index];

      rows.push(
        <Grid
          disabled={true}
          container
          key={odd.properties.uuid}
          className={
            operatorBlockedOdds.findIndex((bo) => bo.uuid == odd.properties.uuid) > -1
              ? odd.ml
                ? "filtered-grid-item-ml"
                : "filtered-grid-item"
              : odd.ml
              ? "grid-item-ml"
              : "grid-item"
          }
        >
          <Grid item style={{ minWidth: "70%", width: "70%" }}>
            <div className="odd-label">
              <div id={odd.properties.uuid} style={{ display: "flex" }}>
                <div style={{ transform: "scale(0.7)", width: "50px" }}>
                  <Tooltip title={!odd.filtered ? "Block Odd" : "UnBlock Odd"} placement="top">
                    <Switch
                      style={{ marginRight: "5px" }}
                      name="market-filter-switch"
                      color="warning"
                      checked={
                        operatorBlockedOdds.findIndex((bo) => bo.uuid == odd.properties.uuid) > -1
                          ? !operatorBlockedOdds.find((bo) => bo.uuid == odd.properties.uuid).status
                          : !odd.filtered
                      }
                      disabled={
                        operatorBlockedMarkets.findIndex((bm) => bm.uuid == market.marketId) > -1
                          ? operatorBlockedMarkets.find((bm) => bm.uuid == market.marketId).status
                          : market.filtered
                      }
                      onClick={(e) => setOddFilter(e, odd)}
                    />
                  </Tooltip>
                </div>
                {odd.name
                  ? odd.name === marketUniName
                    ? odd.properties.h + "::" + odd.properties.o + "::" + odd.properties.e
                    : odd.name
                  : odd.properties.h + "::" + odd.properties.o + "::" + odd.properties.e}
              </div>
            </div>
          </Grid>
          <Grid
            container
            style={{
              position: "relative",
              width: "80px !important",
              textAlign: "right",
              marginLeft: "auto",
            }}
            sx={{
              display: odd.status.toLowerCase() == "suspended" ? "none" : "",
              width: "fit-content !important",
            }}
          >
            <Grid item sx={{ maxWidth: "100px" }}>
              <SoftTypography className={odd.change ? "value-" + odd.change : "odd-value"}>
                {showOddWithStyle(odd)}
              </SoftTypography>
            </Grid>
            <Grid
              item
              style={{
                width: "20px",
                display: adminRole ? "" : "none",
                // position: "absolute",
                // right: "0px",
              }}
            >
              <SoftTypography className={"odd-value-bet"}>
                <Icon title="Place bet" onClick={(e) => placeBet(e, odd.properties.uuid)}>
                  toll_outlined_icon{" "}
                </Icon>
              </SoftTypography>
            </Grid>
          </Grid>
          <Grid
            item
            style={{
              // minWidth: "30%",
              // textAlign: "right",
              position: "relative",
              textAlign: "right",
              marginLeft: "auto",
            }}
            sx={{ display: odd.status.toLowerCase() == "suspended" ? "" : "none" }}
          >
            <Icon>lock_outlined_icon </Icon>
          </Grid>
        </Grid>
      );
    }

    // cachedOdds = marketData.odds;

    return (
      <Grid container key={"column-" + index} className="grid-container">
        {rows}
      </Grid>
    );
  }

  function CreateGrid(m) {
    const columns = m.properties.column ?? 2;
    const rowsCount = m.properties.column ? Math.ceil(m.odds.length / columns) : 1;

    m.odds.sort(function (a, b) {
      var aCon1 = a.column;
      var bCon1 = b.column;
      var aCon2 = a.sort;
      var bCon2 = b.sort;
      return aCon1 < bCon1 ? -1 : aCon1 > bCon1 ? 1 : aCon2 < bCon2 ? -1 : aCon2 > bCon2 ? 1 : 0;
    });

    let columnsDom = [];
    //console.log("columns: ", columns, " - rows: ", rowsCount, " - odds: ", m.odds.length);

    if (m.odds.length === 0) return columnsDom;
    if (m.odds[0].column == null) {
      for (let index = 0; index < columns; index++) {
        columnsDom.push(
          createColumn(
            m.odds.filter((odd, oddIndex) => {
              return oddIndex % columns == index;
            }),
            index,
            m.properties.uni_name
          )
        );
      }

      return columnsDom;
    } else {
      for (let index = 0; index < columns; index++) {
        columnsDom.push(
          createColumn(
            m.odds.filter((odd) => odd.column == index),
            index,
            m.properties.uni_name
          )
        );
      }

      return columnsDom;
    }
  }

  async function placeBet(e, oddUuid) {
    const userData = getUserData();
    let getOddsEndpoint = `/api/v1/bets/create`;
    let platformId = userData.defaultPlatform.value;
    //console.log(userData, oddUuid);
    let response = await postData(
      getOddsEndpoint,
      { currency_id: 1, amount: 1, odds: [oddUuid], platformId: platformId },
      {
        Authorization: getAuthorizationHeader(),
      }
    );
    if (response != null) {
      setApiresponse("success");
      setApiResponseMsg("Bet has been sent!");
      setNotification(true);
    } else {
      setApiresponse("error");
      setApiResponseMsg("Bet not Accepted. Something goes wrong try again please!");
      setNotification(true);
    }
  }

  async function setMarketFilter(e, marketId) {
    e.preventDefault();
    market.filtered = !market.filtered;
    const operBlockedMarkets = [...operatorBlockedMarkets];
    const marketIndex = operBlockedMarkets.findIndex((bm) => bm.uuid == marketId);
    if (marketIndex == -1) {
      operBlockedMarkets.push({
        uuid: marketId,
        status: market.filtered,
      });
    } else {
      operBlockedMarkets.splice(marketIndex, 1);
    }
    setOperatorBlockedMarkets(operBlockedMarkets);
    setMarketData(market);

    let fullBlockeddOdds = market.odds
      .filter((o) => o.filtered)
      .map((o) => {
        return o.properties.uuid;
      })
      .concat(
        market.delblockedOdds.map((o) => {
          return o.uuid;
        })
      );

    fullBlockeddOdds = [...new Set(fullBlockeddOdds)];
    console.log(fullBlockeddOdds);

    informParent(e, {
      type: "marketChange",
      data: {
        uuid: marketId,
        status: market.filtered,
        odds: fullBlockeddOdds,
      },
    });
    e.stopPropagation();
  }

  async function setOddFilter(e, odd) {
    e.preventDefault();
    const f_odd = market.odds.find((fo) => fo.properties.uuid == odd.properties.uuid);
    f_odd.filtered = !f_odd.filtered;
    const operBlockedOdds = [...operatorBlockedOdds];
    const oddIndex = operBlockedOdds.findIndex((bo) => bo.uuid == odd.properties.uuid);
    if (oddIndex == -1) {
      operBlockedOdds.push({
        uuid: odd.properties.uuid,
        status: f_odd.filtered,
        market_uuid: market.marketId,
      });
    } else {
      operBlockedOdds.splice(oddIndex, 1);
    }
    setOperatorBlockedOdds(operBlockedOdds);
    setMarketData(market);

    let fullBlockeddOdds = market.odds
      .filter((o) => o.filtered)
      .map((o) => {
        return o.properties.uuid;
      })
      .concat(
        market.delblockedOdds.map((o) => {
          return o.uuid;
        })
      );

    fullBlockeddOdds = [...new Set(fullBlockeddOdds)];
    console.log(fullBlockeddOdds);

    informParent(e, {
      type: "marketChange",
      data: {
        uuid: market.marketId,
        status: marketData.filtered,
        odds: fullBlockeddOdds,
      },
    });
    e.stopPropagation();
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  useEffect(() => {
    if (market) {
      // console.log(oddsStyle);
      for (let index = 0; index < market.odds.length; index++) {
        const odd = market.odds[index];
        const f_odd = cachedOdds.find((fo) => fo.properties.uuid == odd.properties.uuid);

        odd.change = null;
        if (f_odd) {
          if (f_odd.odd !== odd.odd) {
            // console.log(market.name);
            // console.log("f_odd: ", odd.name, "->", f_odd.value, " - ", odd.value);
            if (odd.status.toLowerCase() === "new") {
              if (odd.odd - f_odd.odd > 0) odd.change = "up";
              if (odd.odd - f_odd.odd < 0) odd.change = "down";
              // console.log("change -> ", odd.change);
            } else {
              //console.log("changes with STATUS: ", odd.status.toLowerCase());
              if (odd.odd - f_odd.odd > 0) odd.change = "up";
              if (odd.odd - f_odd.odd < 0) odd.change = "down";
            }
          }
        }
      }

      setCachedOdds(market.odds);

      setMarketData(market);
    }
  }, [market]);

  useEffect(() => {
    if (massClose !== null) {
      //console.log("forceCloseHandling..", massClose);
      setOpen(!massClose);    }
  }, [massClose]);

  useEffect(() => {
    if (releaseOperBlocked) {
      setOperatorBlockedMarkets([]);
      setOperatorBlockedOdds([]);
      informParent(new Event("fake event"), { type: "releaseCompleted", data: null });
    }
  }, [releaseOperBlocked]);

  return (
    <React.Fragment>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <Table className="market-box">
        {marketData ? (
          <TableBody>
            <TableRow
              id={marketData.marketId}
              className={
                operatorBlockedMarkets.findIndex((bm) => bm.uuid == marketData.marketId) > -1
                  ? open
                    ? "market-filtered-open"
                    : "market-filtered-closed"
                  : open
                  ? "market-open"
                  : "market-closed"
              }
              sx={{ "& > *": { borderBottom: "unset" } }}
              onClick={(e) => clickHandler(e, { name: marketData.name, id: marketData.marketId })}
              title={marketData.name + "-" + marketData.id}
            >
              <TableCell
                style={{
                  borderBottom: "unset",
                  width: "100%",
                }}
                align="left"
              >
                <span
                  style={{
                    display: marketData.name ? "" : "none",
                    marginRight: "10px",
                  }}
                >
                  {marketData.name}
                </span>
                <span style={{ display: marketData.name ? "none" : "", marginRight: "10px" }}>
                  {marketData.properties.uni_name} ({marketData.properties.numbers.join("-")})
                </span>
                <Tooltip
                  title={!marketData.filtered ? "Block Market" : "UnBlock Market"}
                  placement="top"
                >
                  <Switch
                    className="test"
                    name="market-filter-switch"
                    color="info"
                    checked={
                      operatorBlockedMarkets.findIndex((bm) => bm.uuid == marketData.marketId) > -1
                        ? !operatorBlockedMarkets.find((bm) => bm.uuid == marketData.marketId)
                            .status
                        : !marketData.filtered
                    }
                  />
                </Tooltip>
              </TableCell>

              <TableCell
                style={{
                  minWidth: "20px",
                  width: "20px",
                  borderBottom: "unset",
                  position: "relative",
                }}
              >
                <Icon
                  sx={{
                    display: marketData.status.toLowerCase() == "suspended" ? "" : "none",
                    position: "absolute",
                    right: "50px",
                    top: "20px",
                  }}
                >
                  lock_outlined_icon{" "}
                </Icon>
                <IconButton aria-label="expand row" size="small">
                  {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
              </TableCell>
            </TableRow>
            <TableRow
              id={marketData.marketId + "-odds-Holder "}
              sx={{ "& > *": { borderBottom: "unset" } }}
              style={{ display: open ? "" : "none" }}
            >
              <TableCell
                style={{ borderBottom: "unset", width: "100%" }}
                align="left"
                colSpan={2}
                className="odds-column-grid-holder"
              >
                <SoftBox className="odds-grid-holder">{CreateGrid(marketData)}</SoftBox>
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody></TableBody>
        )}
      </Table>
    </React.Fragment>
  );
}

// Setting default values for the props of CreatePlatform
MarketView.defaultProps = {
  oddsStyle: "decimal",
};

// Typechecking props for the DataTable
MarketView.propTypes = {
  market: PropTypes.object,
  massClose: PropTypes.bool,
  oddsStyle: PropTypes.string,
  informParent: PropTypes.func,
  releaseOperBlocked: PropTypes.bool,
};

export default MarketView;
